import ApiBase from '../ApiBase';

class Sessions extends ApiBase {
    route = '/main-stage/sessions';
}

export default new Sessions;
